<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />
      <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-content">
          <div class="row">
            <div class="col-xl-12">
              <div
                class="m-portlet m-portlet--rounded m-portlet--bordered m-portlet--head-sm m-portlet--unair"
                :m-portlet="'true'"
              >
                <form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                  <div class="m-portlet__body">
                    <div class="m-pricing-table-2">
                      <div class="m-pricing-table-2__head">
                        <div class="m-pricing-table-2__title">
                          <h3 class="text-center">
                            {{ $t('advertise.ContractPropertyServices') }}
                          </h3>
                          <div class="container mt-4">
                            <p>{{ $t('advertise.PropertyServiceDesc') }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="m-pricing-table-2__content">
                        <div class="m-pricing-table-2__container">
                          <div class="container">
                            <div class="m-pricing-table-2__items row">
                              <div class="m-pricing-table-2__item col-lg-6">
                                <h2 class="m-pricing-table-2__subtitle mb-5">
                                  {{ $t('advertise.Featured') }}
                                </h2>
                                <template
                                  v-for="(pkg, key, i) in featuredPkgs"
                                  :key="pkg.properties"
                                >
                                  <div
                                    :id="`Featured${pkg.properties}`"
                                    :class="{ price_container: true, 'active': isFeaturedServiceSelected( pkg.properties ) }"
                                  >
                                    <div :class="{'m-pricing-table-2__features mb-0': true, 'mt-3': i >= 1}">
                                      <span>
                                        {{ pkg.properties }}
                                        <template v-if="pkg.properties === 1">
                                          {{ $t('advertise.Property') }}
                                        </template>
                                        <template v-else>
                                          {{ $t('advertise.Properties') }}
                                        </template>
                                      </span>
                                    </div>
                                    <span class="m-pricing-table-2__price">{{ pkg.price }}</span>
                                    <span class="m-pricing-table-2__label">€</span>
                                    <div class="m-pricing-table-2__btn mt-0">
                                      <button
                                        type="button"
                                        class="btn m-btn--pill  btn-primary m-btn--wide m-btn--uppercase m-btn--bolder m-btn--lg"
                                        data-toggle="button"
                                        aria-pressed="false"
                                        @click="selectFeaturedService( pkg.properties, pkg.price )"
                                      >
                                        {{ $t('advertise.Contract') }}
                                      </button>
                                    </div>
                                  </div>
                                  <div
                                    v-if="i !== Object.values( featuredPkgs ).length - 1"
                                    class="row separata"
                                  />
                                </template>
                              </div>
                              <div class="m-pricing-table-2__item col-lg-6">
                                <h2 class="m-pricing-table-2__subtitle mb-5">
                                  {{ $t('advertise.Premium') }}
                                </h2>
                                <template
                                  v-for="(pkg, key, i) in premiumPkgs"
                                  :key="pkg.properties"
                                >
                                  <div
                                    :id="`Premium${pkg.properties}`"
                                    :class="{ price_container: true, 'active': isPremiumServiceSelected( pkg.properties ) }"
                                  >
                                    <div :class="{'m-pricing-table-2__features mb-0': true, 'mt-3': i >= 1}">
                                      <span>
                                        {{ pkg.properties }}
                                        <template v-if="pkg.properties === 1">
                                          {{ $t('advertise.Property') }}
                                        </template>
                                        <template v-else>
                                          {{ $t('advertise.Properties') }}
                                        </template>
                                      </span>
                                    </div>
                                    <span class="m-pricing-table-2__price">{{ pkg.price }}</span>
                                    <span class="m-pricing-table-2__label">€</span>
                                    <div class="m-pricing-table-2__btn mt-0">
                                      <button
                                        type="button"
                                        class="btn m-btn--pill  btn-primary m-btn--wide m-btn--uppercase m-btn--bolder m-btn--lg"
                                        data-toggle="button"
                                        aria-pressed="false"
                                        @click="selectPremiumService( pkg.properties, pkg.price )"
                                      >
                                        {{ $t('advertise.Contract') }}
                                      </button>
                                    </div>
                                  </div>
                                  <div
                                    v-if="i !== Object.values( premiumPkgs ).length - 1"
                                    class="row separata"
                                  />
                                </template>
                              </div>
                              <div class="col-lg-12 separata d-md-none d-sm-none d-none d-lg-block">
                                &nbsp;
                              </div>
                              <div
                                v-if="selectedFeaturedService.Properties || selectedPremiumService.Properties"
                                class="col-lg-12 text-center pt-5"
                              >
                                <span class="pb-5">
                                  <h4>
                                    {{ totalText }}
                                  </h4>
                                </span>
                                <button
                                  class="btn m-btn--pill mt-5 btn-success m-btn--wide btn-block"
                                  @click.stop.prevent="sendForm"
                                >
                                  {{ $t('advertise.SendContract') }}
                                </button>
                              </div>
                              <div class="col-lg-12 text-center pt-4 mt-2">
                                <span
                                  v-if="selectedFeaturedService.Properties || selectedPremiumService.Properties"
                                  class="d-block d-md-block d-lg-inline ml-lg-4 "
                                >
                                  <i class="la la-asterisk m--icon-font-size-sm3" /> {{ $t('advertise.PricesWithoutVAT') }}
                                </span>
                                <span class="d-block m--icon-font-size-sm4">
                                  {{ $t('advertise.ToContractDirectoryServicesPleaseGoTo') }} <router-link
                                    :to="{ name:
                                      'AdvertiseDir'}"
                                    class="m-menu__link"
                                  >{{ $t('advertise.ContractDirectoryServicesv2') }}</router-link>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>
<script>
import AppHeader from '../common/Header.vue';
import AppFooter from '../common/Footer.vue';
import LeftMenu from '../common/menus/LeftMenu.vue';
import { getUser, onBeforeOpenSwal } from '../../../functions.ts';
import { clientapi } from '../../../api-clients/client-api.js';
import { featuredPropertyPackages, premiumPropertyPackages } from './property-pricing.js';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
    },
    data() {
        return {
            selectedFeaturedService: {},
            selectedPremiumService: {},
        };
    },
    computed: {
        premiumPkgs() {
            return premiumPropertyPackages;
        },
        featuredPkgs() {
            return featuredPropertyPackages;
        },
        totalText() {
            return this.$t( 'advertise.TOTAL' ) + ': ' + ( ( this.selectedFeaturedService.Price ? this.selectedFeaturedService.Price : 0 ) + ( this.selectedPremiumService.Price ? this.selectedPremiumService.Price : 0 ) ) + '€*' +
        '/' + this.$t( 'common.month' ) + ' (' +
        ( this.selectedFeaturedService.Properties ? `${this.selectedFeaturedService.Properties} ${this.$t( 'homepage.stats.FeaturedProperties' )}` : '' ) +
        ( this.selectedFeaturedService.Properties && this.selectedPremiumService.Properties ? ' & ' : '' ) +
        ( this.selectedPremiumService.Properties ? `${this.selectedPremiumService.Properties} ${this.$t( 'homepage.stats.PremiumFeatured' )}` : '' ) +
        ')';
        },
    },
    mounted() {
        if ( this.$route.query.featured && parseInt( this.$route.query.featured ) > 0 && featuredPropertyPackages[ parseInt( this.$route.query.featured ) ] ) {
            const selectedPackage = parseInt( this.$route.query.featured );
            this.selectFeaturedService( selectedPackage, featuredPropertyPackages[ selectedPackage ].price );
        }

        if ( this.$route.query.premium && parseInt( this.$route.query.premium ) > 0 && premiumPropertyPackages[ parseInt( this.$route.query.premium ) ] ) {
            const selectedPackage = parseInt( this.$route.query.premium );
            this.selectPremiumService( selectedPackage, premiumPropertyPackages[ selectedPackage ].price );
        }
    },
    methods: {
        async sendForm() {
            let services = [];

            if ( this.selectedFeaturedService.Properties > 0 ) {
                services.push( 'featured' + this.selectedFeaturedService.Properties );
            }
            if ( this.selectedPremiumService.Properties > 0 ) {
                services.push( 'premium' + this.selectedPremiumService.Properties );
            }

            const user = getUser();

            const params = {
                'subject': 'New Property Services Request',
                'body': `Property Services to contract: ${services.join( ',' )}<br>User: ${user.Login}<br>${this.totalText} `,
                'language': this.$i18n.locale,
            };

            const response = await clientapi.post( '/contact-advertise', params );

            if ( response.status === 200 ) {
                swal( {
                    title: this.$t( 'advertise.FormSubmitedTitle' ),
                    text: this.$t( 'advertise.FormSubmitedText' ),
                    type: 'success',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
            } else {
                let errorCode = response.data.code;
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( 'error.server.' + errorCode ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
            }
        },
        updateRouteParams() {
            let query = {};

            if ( this.selectedFeaturedService && this.selectedFeaturedService.Properties && this.selectedFeaturedService.Properties > 0 ) {
                query[ 'featured' ] = this.selectedFeaturedService.Properties;
            }

            if ( this.selectedPremiumService && this.selectedPremiumService.Properties && this.selectedPremiumService.Properties > 0 ) {
                query[ 'premium' ] = this.selectedPremiumService.Properties;
            }

            this.$router.push( { query: query } );
        },
        selectFeaturedService( properties, priceInEuro ) {
            if ( this.isFeaturedServiceSelected( properties ) ) {
                this.selectedFeaturedService = {};
            } else {
                this.selectedFeaturedService = {
                    Properties: properties,
                    Price: priceInEuro,
                };
            }

            this.updateRouteParams();
        },
        selectPremiumService( properties, priceInEuro ) {
            if ( this.isPremiumServiceSelected( properties ) ) {
                this.selectedPremiumService = {};
            } else {
                this.selectedPremiumService = {
                    Properties: properties,
                    Price: priceInEuro,
                };
            }

            this.updateRouteParams();
        },
        isFeaturedServiceSelected( properties ) {
            return this.selectedFeaturedService.Properties === properties;
        },
        isPremiumServiceSelected( properties ) {
            return this.selectedPremiumService.Properties === properties;
        },
    },
};
</script>
<style scoped lang="scss">
  .m-pricing-table-2__items,
  .m-pricing-table-2__item {
    background-color: #f8f6f5 !important;
  }

  .m-pricing-table-2__items {
    box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.1) !important;
  }
</style>
